import { Component, OnInit } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import moment from 'moment';
import { CreateFormDeliveryTimeStore } from './create-form-delivery-time.store';
import { TimesMockStore } from 'src/app/shared/store-mocks/times.store';

@Component({
  selector: 'app-create-form-delivery-time',
  templateUrl: './create-form-delivery-time.component.html',
  styleUrls: ['./create-form-delivery-time.component.scss'],
  providers: [CreateFormDeliveryTimeStore, TimesMockStore]
})
export class CreateFormDeliveryTimeComponent implements OnInit, ControlValueAccessor {


  constructor(
    public ngControl: NgControl,
    private store: CreateFormDeliveryTimeStore
  ) {
    ngControl.valueAccessor = this;
  }

  // vm$ = this.store.vm$
  value: any = ''

  onChange: any = () => {}
  onTouch: any = () => {}

  times$ = this.store.entities$

  ngOnInit(): void {


  }

  writeValue(value: string | undefined){
    if(value){
      this.value = value
    }
  }

  registerOnChange(fn: any){
    this.onChange = fn
  }

  registerOnTouched(fn: any){
    this.onTouch = fn
  }


  modelChange(value: string){
    if(!this.ngControl.touched){
      this.onTouch()
    }

    this.onChange(value)
  }

  onValueChange(event: any){
    this.modelChange(event)
  }
}
